import React, { SFC, ReactElement } from 'react';
import { Route } from 'react-router-dom';

export interface Props {
    code: number;
}

const StatusCodeComponentWrapper: SFC<Props> = ({ code, children }): ReactElement => {
    return (
        <Route
            render={({ staticContext }) => {
                if (staticContext) {
                    // `status` is user defined key, which we use
                    // to setup complete https request handling in express app.
                    // @ts-ignore
                    // eslint-disable-next-line no-param-reassign
                    staticContext.status = code;
                }

                return children || '';
            }}
        />
    );
};

export default StatusCodeComponentWrapper;
